import { Box, Button, Center, Paper, Stack, Text as MantineText, ThemeIcon, Title } from '@mantine/core';
import { IconHome, IconLock } from '@tabler/icons';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

type PermissionDeniedPageProps = {
  title: string;
  description: string;
  buttonLabel: string;
  backTo?: string;
};

const PermissionDeniedPage: FC<PermissionDeniedPageProps> = ({ title, description, buttonLabel, backTo = '/' }) => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <Box
      component="main"
      sx={(theme) => ({
        minHeight: '100vh',
        width: '100%',
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
        '@supports (height: 100dvh)': {
          minHeight: '100dvh',
        },
      })}
    >
      <Center sx={{ minHeight: 'inherit', padding: 24 }}>
        <Paper
          shadow="sm"
          radius="md"
          p="xl"
          sx={(theme) => ({
            maxWidth: 520,
            width: '100%',
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
            border: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2]}`,
          })}
        >
          <Stack align="center" spacing="md">
            <ThemeIcon size={54} radius="xl" color="red" variant="light">
              <IconLock size={30} />
            </ThemeIcon>
            <Box sx={{ textAlign: 'center' }}>
              <Title order={2} size="h3" mb="sm">
                {title}
              </Title>
              <MantineText color="dimmed">{description}</MantineText>
            </Box>
            <Button mt="sm" leftIcon={<IconHome size={18} />} onClick={() => navigate(backTo)}>
              {buttonLabel}
            </Button>
          </Stack>
        </Paper>
      </Center>
    </Box>
  );
};

export default PermissionDeniedPage;
